(function () {
  'use strict';

  /* @ngdoc object
   * @name rols.llista
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols.main.llista', [
      'ui.router'
    ]);
}());
